export default __webpack_public_path__ + "static/media/moreAboutPackages.60adcb7e.svg";